import { render } from "./logEntryFlex.vue?vue&type=template&id=b5d83110&scoped=true&ts=true"
import script from "./logEntryFlex.vue?vue&type=script&lang=ts"
export * from "./logEntryFlex.vue?vue&type=script&lang=ts"

import "./logEntryFlex.vue?vue&type=style&index=0&id=b5d83110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d83110"]])

export default __exports__